export enum SaleState {
  Unavailable,
  Available,
  OutOfStock,
  Unaffordable,
  LogInRequired,
  LinkRequired
}
